import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ProductConfigDetailsService } from './core/product-config-details.service';
import { BehaviorSubject, Subscription, take } from 'rxjs';
import { OrderEntry } from '@spartacus/cart/base/root';
import { ProductConfigStatusRequest } from './core/product-config-details.model';
import { initialStatus } from '../../../../../../core/models/request-status.model';
import { Alert, ALERT_TYPE } from '../../../../../../components/alert/alert.model';
import { I18nModule } from '@spartacus/core';
import { AlertComponent } from '../../../../../../components/alert/alert.component';
import { LocalLoaderComponent } from '../../../../../../components/loader/local-loader/local-loader.component';
import { TableProComponent } from '../../../../../../components/table-pro/table-pro.component';
import { TableProConfig } from '../../../../../../components/table-pro/core/table-pro.model';
import { ModalService } from '../../../../../../components/modal-list/modal-list.service';

@Component({
  selector: 'modal-config-details',
  standalone: true,
  imports: [CommonModule, I18nModule, AlertComponent, LocalLoaderComponent, TableProComponent],
  templateUrl: './modal-config-details.component.html',
  styleUrl: './modal-config-details.component.scss',
})
export class ModalConfigDetailsComponent implements OnInit, OnDestroy {
  @Input() data?: {
    entry: OrderEntry;
  };

  req$ = new BehaviorSubject<ProductConfigStatusRequest>(initialStatus);
  subscription = new Subscription();

  alertMessage: Alert = {
    isActive: true,
    title: '',
    content: '',
    containerClass: 'm-t-20',
    hasCloseButton: false,
    type: ALERT_TYPE.DANGER,
  };

  tableConfig: TableProConfig = {
    classContainer: 'm-t-12',
    collumnConfig: [
      { id: 'type', index: 0, type: 'text' },
      { id: 'name', index: 1, type: 'text' },
      { id: 'description', index: 2, type: 'text' },
      { id: 'quantity', index: 3, type: 'number' },
      { id: 'unitPrice', index: 4, type: 'number' },
      { id: 'extendedPrice', index: 5, type: 'number' },
    ],
  };

  constructor(
    private productConfigDetailsService: ProductConfigDetailsService,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.getProductConfigDetails();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  close() {
    this.modalService.close();
  }

  getProductConfigDetails() {
    this.subscription.add(
      this.productConfigDetailsService
        .getProductConfigDetails({
          quoteNumber: this.data?.entry.quote,
          productConfigurationCode: this.data?.entry.productConfigurationCode,
          productConfigurationRevision: this.data?.entry.productConfigurationRevision,
        })
        .pipe(take(1))
        .subscribe(response => this.req$.next(response)),
    );
  }
}
